/**
 * The wire contract.
 *
 * Every endpoint returns one of exactly two shapes. The web client's fetch wrapper
 * unwraps them centrally, so no feature ever writes `if (res.data.data)`.
 */
export function isApiFailure(r) {
    return r.success === false;
}
/**
 * Machine-readable error codes.
 *
 * The client switches on these, never on `message`. Messages are for humans and are
 * expected to change; codes are part of the contract.
 */
export const ERROR_CODES = {
    // 400 / 422
    VALIDATION_ERROR: "VALIDATION_ERROR",
    INVALID_INPUT: "INVALID_INPUT",
    DUPLICATE: "DUPLICATE",
    // 401 / 403
    UNAUTHENTICATED: "UNAUTHENTICATED",
    TOKEN_EXPIRED: "TOKEN_EXPIRED",
    TOKEN_INVALID: "TOKEN_INVALID",
    INVALID_CREDENTIALS: "INVALID_CREDENTIALS",
    ACCOUNT_LOCKED: "ACCOUNT_LOCKED",
    ACCOUNT_DISABLED: "ACCOUNT_DISABLED",
    FORBIDDEN: "FORBIDDEN",
    PERMISSION_DENIED: "PERMISSION_DENIED",
    // 404 / 409
    NOT_FOUND: "NOT_FOUND",
    CONFLICT: "CONFLICT",
    STATE_CONFLICT: "STATE_CONFLICT",
    // Financial domain — these drive specific UI treatment, not just a toast
    INSUFFICIENT_BALANCE: "INSUFFICIENT_BALANCE",
    UNBALANCED_ENTRY: "UNBALANCED_ENTRY",
    PERIOD_CLOSED: "PERIOD_CLOSED",
    IMMUTABLE_TRANSACTION: "IMMUTABLE_TRANSACTION",
    ALREADY_REVERSED: "ALREADY_REVERSED",
    APPROVAL_REQUIRED: "APPROVAL_REQUIRED",
    CREDIT_LIMIT_EXCEEDED: "CREDIT_LIMIT_EXCEEDED",
    ACCOUNT_INACTIVE: "ACCOUNT_INACTIVE",
    SELF_TRANSFER: "SELF_TRANSFER",
    // 429 / 5xx
    RATE_LIMITED: "RATE_LIMITED",
    INTERNAL_ERROR: "INTERNAL_ERROR",
    SERVICE_UNAVAILABLE: "SERVICE_UNAVAILABLE",
};
export const DEFAULT_PAGE_SIZE = 50;
export const MAX_PAGE_SIZE = 200;
//# sourceMappingURL=api.js.map